<template>
  <vx-card class="mt-2 pagebreak-inside-avoid">
    <table class="table table-bordered">
      <tr class="title p-1 w-full">
        <th colspan="4">FRANQUIA</th>
      </tr>
      <tr>
        <td class="pl-3">{{ comprehensiveLabel }}</td>
        <td class="pl-3">
          <b>Franquia</b>:
          {{
            selectFranchiseCoverage.length
              ? functions.formataReal(
                  getComprehensiveFranchise(selectFranchiseCoverage),
                )
              : 'R$ 0,00'
          }}
        </td>
        <td v-if="selectedGlass.length > 0" class="pl-3">
          {{ formatNameGlass(selectedGlass[0].name) }}
        </td>
        <td v-if="selectedGlass.length > 0" class="pl-3">
          <b>Franquia</b>:
          {{ functions.formataReal(selectedGlass[0].value) }}
        </td>
      </tr>
      <tr
        v-for="(item, index) in selectedGlass"
        :key="index"
        v-if="index % 2 !== 0"
      >
        <td class="pl-3">
          {{ formatNameGlass(item.name) }}
        </td>
        <td class="pl-3">
          <b>Franquia</b>:
          {{ functions.formataReal(item.value) }}
        </td>
        <td v-if="selectedGlass[index + 1]" class="pl-3">
          {{ formatNameGlass(selectedGlass[index + 1].name) }}
        </td>
        <td v-if="selectedGlass[index + 1]" class="pl-3">
          <b>Franquia</b>:
          {{ functions.formataReal(selectedGlass[index + 1].value) }}
        </td>
      </tr>
    </table>
    <div
      v-if="customSectionsMsgs.FRANCHISE"
      style="text-align: justify"
      class="pl-3 pt-3"
      v-html="customSectionsMsgs.FRANCHISE"
    ></div>
  </vx-card>
</template>

<script>
import {
  getAllFranchises,
  getComprehensiveFranchise,
  getFormattedItemLmi,
  getSelectedGlassServices,
} from '../../../services/contract';
import { TRANSLATE_GLASS_FRANCHISES } from '../../../utils/constants';
import functions from '../../../utils/functions';

export default {
  name: 'EndorsementContractGlassFranchise',
  props: {
    quotationData: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    customSectionsMsgs: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {
      functions,
      getFormattedItemLmi,
      getComprehensiveFranchise,
      comprehensiveLabel: 'Casco compreensivo',
    };
  },
  computed: {
    selectFranchiseCoverage() {
      const coverageContracted =
        this.quotationData && this.quotationData.coverage_contracted;
      const allCoverages = this.quotationData.all_coverages;
      return functions.getEndorsementContractedProductsWithDetails(
        coverageContracted,
        allCoverages,
        false,
      );
    },
    selectedGlass() {
      const glassServices = this.selectGlassServices();
      return getAllFranchises(glassServices);
    },
  },
  methods: {
    formatNameGlass(name) {
      return TRANSLATE_GLASS_FRANCHISES[name] || name;
    },
    selectGlassServices() {
      return getSelectedGlassServices(
        this.quotationData.coverage_contracted,
        this.quotationData.all_coverages.details,
      );
    },
  },
};
</script>
